/**
 * THE KICKSTARTER BACKER COSMETICS — every skin and name style the campaign promised, each GRANTABLE ON ITS OWN.
 *
 * A key is "kind:id" in the cosmetic families' own spelling (sim/cosmetics.ts): `pot`, `building` (the greenhouse
 * shell), `shelf` (the rack skin), `frame` (the avatar border), plus `name` for a name style. An admin grants one
 * from the account page's Kickstarter panel; the server books it on the grant ledger (`grantsCredited.cosmetics`,
 * server/redeem.js), and the game and server read ownership from there. The ledger is server-owned, so a stale tab
 * can never write a grant away.
 *
 * GRANTABLE BEFORE IT IS BUILT. Four of these are still concept art (the Void Anodized pot, the Founders'
 * Conservatory, the Black Nickel & Gold racks, the Cloisonné border). They can be granted today: the key sits on
 * the ledger, inert — every picker walks its own registry, so an id it does not know is never shown — and opens
 * the moment the skin ships. WHEN YOU BUILD ONE, give it EXACTLY the id below and flag it `reward: true` in its
 * registry (pot skins are locked by default), or it opens for every player instead of only the backers granted it.
 *
 * Import-free on purpose: sim/achievements.ts (backer-exclusive skins) and sim/rewardPacks.ts (the admin list)
 * both read it, and the redeem registry generator copies it into server/redeemRegistry.json for the server.
 * The names are the CAMPAIGN'S (Shelf Garden Kickstarter/tools/rewards.mjs ITEMS) — what backers were promised.
 */

export interface BackerCosmetic {
  /** "kind:id" */
  key: string;
  /** as the campaign printed it */
  name: string;
  /** what sort of thing it is, as the campaign labelled it */
  kind: string;
  desc: string;
}

export const BACKER_COSMETICS: readonly BackerCosmetic[] = [
  { key: "pot:foundersGilt", name: "Founder's Gilt pot", kind: "Pot skin",
    desc: "A footed chalice in green-black enamel, banded in gold." },
  { key: "frame:cloisonne", name: "Founder's Cloisonné avatar border", kind: "Avatar border",
    desc: "A gold and dark enamel frame around your profile picture." },
  { key: "shelf:blackNickel", name: "Black Nickel & Gold racks", kind: "Greenhouse rack skin",
    desc: "Gunmetal shelves on gold posts." },
  { key: "building:foundersConservatory", name: "Founders' Conservatory", kind: "Greenhouse skin",
    desc: "The whole greenhouse in black iron with gold trim." },
  { key: "pot:voidAnodized", name: "Void Anodized pot", kind: "Pot skin",
    desc: "The Founder's chalice in near-black enamel with rainbow bands." },
  { key: "name:founderGold", name: "Founder's Gold name style", kind: "Name style",
    desc: "Name and tag in animated gold." },
  { key: "name:iridescent", name: "Iridescent name style", kind: "Name style",
    desc: "Name and tag in flowing holographic color." },
];

export const BACKER_COSMETIC_KEYS: ReadonlySet<string> = new Set(BACKER_COSMETICS.map((c) => c.key));
